// extracted by mini-css-extract-plugin
export default {"font-renta":"DepotWork_font-renta__vrl6i","depotWork":"DepotWork_depotWork__EwQux","button":"DepotWork_button__4YZc5"};